const updateServiceTypes = {
  toastr: 'Tipo de Servicio actualizado',
  toastr1: ' fue actualizado con éxito',
  toastrError: 'Tipo de Servicio ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default updateServiceTypes;
